const orderStatus = {
  /* incoming: 117198, */
  all: 1,
  /*   incoming: 117198,
  confirmed: "confirmed",
  ready: "ready",
  dispatched: "dispatched",
  completed: "completed",*/
  /* cancelled: "Cancelled",
  reject: "Rejected", */
};

export default orderStatus;
